import {useState, useEffect} from 'react'

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import AccordionGroup from 'components/Accordion/AccordionGroup'

import MDButton from "components/MDButton";
import Card from "@mui/material/Card";
import { timeConverter } from 'timeConverter/timeConverter';
import Icon from "@mui/material/Icon"

import DataTable from "examples/Tables/DataTable";

/* eslint-disable react/prop-types */
export default function ModalCampaignData({campaign, campaignImage}) {

    let surveyType = false
    let discountType = false

    let productType = false
    let shopType = false

    let systemType = false

    if(campaign){
        systemType = campaign['campaign']['type'] === 'PERSONAL_DATA' || campaign['campaign']['type'] === 'PRODUCT_DEFAULT'
        surveyType = 'survey_definition_id' in campaign['campaign'] && campaign['campaign']['type'] !== 'PERSONAL_DATA' && campaign['campaign']['type'] !== 'PRODUCT_DEFAULT'
        discountType = 'discounts' in campaign['campaign']
        productType = campaign['campaign']['type'] === 'PRODUCT'
        shopType = campaign['campaign']['type'] === 'SHOP'
        
    }

    return (
        <>
        {campaign && 
            <Grid container spacing={1} width={"32rem"} height={"35rem"}>
                <Grid item xs={12} >
                    <MDBox display="block" alignItems="center" lineHeight={1} pt={1} pl={2} pr={2}>
                    <MDBox display="flex" justifyContent="left" alignItems="center">
                          {campaignImage(campaign)}
                          <MDBox>
                            {productType &&
                                <MDBox display="block" mb={1}>
                                    <MDBox display="flex"  justifyContent="space-between">
                                        <MDTypography variant="button" color="dark" fontWeight="medium" sx={{maxWidth:"60%"}}>
                                            {campaign['product']['product_name']}
                                        </MDTypography>
                                        <MDTypography variant="button" color="dark" fontWeight="regular" ml={2}>
                                            {campaign['product']['product_code']}
                                        </MDTypography>
                                        <Icon>edit</Icon>
                                    </MDBox>
                                    <MDTypography component="div" variant="button" color="text" fontWeight="regular" mt={1}>
                                        <MDTypography variant="button" color="dark" fontWeight="medium">
                                            {"Product category: "}
                                        </MDTypography>
                                    {campaign['product']['product_category']}
                                    </MDTypography>
                                </MDBox>
                            }
                            {shopType &&
                                <MDBox mb={1}>
                                    <MDBox display="flex" justifyContent="space-between">
                                        <MDTypography component="div" variant="button" color="dark" fontWeight="medium">
                                            {campaign['shop']['shop_name']}
                                        </MDTypography>
                                        <Icon>edit</Icon>
                                    </MDBox>
                                    <MDTypography component="div" variant="button" color="text" fontWeight="regular">
                                        <MDTypography variant="button" color="dark" fontWeight="medium">
                                            {"Shop category: "}
                                        </MDTypography>
                                    {campaign['shop']['shop_category']}
                                    </MDTypography>
                                </MDBox>
                            }
                          </MDBox>
                        </MDBox>
                        <MDBox pt={1}>
                            {!systemType && 
                                <MDBox display="flex" mt={1} mb={1} alignItems="center">
                                <MDTypography component="div" variant="button" color="dark" fontWeight="medium" mr={2}>
                                    {'Campaign type:'}
                                </MDTypography>
                                    <MDBox>
                                        {surveyType && 
                                        <MDTypography component="div" variant="button" color="text" fontWeight="medium">
                                            {'SURVEY'}
                                        </MDTypography>
                                        }
                                        {discountType && 
                                        <MDTypography component="div" variant="button" color="text" fontWeight="medium">
                                            {'DISCOUNT'}
                                        </MDTypography>
                                        }
                                    </MDBox>
                                </MDBox>
                            }
                            <MDBox display="flex" justifyContent="space-between">
                                <MDTypography component="div" variant="button" color="text" fontWeight="regular">
                                    <MDTypography variant="button" color="dark" fontWeight="medium">
                                        {"Campaign description: "}
                                    </MDTypography>
                                    {campaign['campaign']['description']}
                                </MDTypography>
                            </MDBox>
                            <MDTypography component="div" variant="button" color="text" fontWeight="regular">
                                    <MDTypography variant="button" color="dark" fontWeight="medium">
                                        {"Campaign duration: "}
                                    </MDTypography>
                                {timeConverter(campaign['campaign']['start_date']) + " - " + timeConverter(campaign['campaign']['end_date'])}
                            </MDTypography>
                            <MDTypography component="div" variant="button" color="text" fontWeight="regular">
                                    <MDTypography variant="button" color="dark" fontWeight="medium">
                                        {"Created at: "}
                                    </MDTypography>
                                {timeConverter(campaign['campaign']['created_at'])}
                            </MDTypography>
                            <MDTypography component="div" variant="button" color="text" fontWeight="regular">
                                    <MDTypography variant="button" color="dark" fontWeight="medium">
                                        {"Updated at: "}
                                    </MDTypography>
                                {timeConverter(campaign['campaign']['updated_at'])}
                            </MDTypography>
                            <MDBox mt={2}>
                                <MDTypography variant="button" color="dark" fontWeight="medium" >
                                    {campaign['campaign']['type'] === "PERSONAL_DATA" ? 
                                        "This campaign applies to users with level " + campaign['campaign']['target_min_level'] + " only."
                                        :
                                        "This campaign applies to users with min level " + campaign['campaign']['target_min_level'] + "."
                                    }
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        {discountType &&
                            <MDBox pt={4} pb={1}>
                                <MDBox pb={1}>
                                <MDTypography variant="text" color="text" fontWeight="bold">
                                    Discounts&nbsp;&nbsp;&nbsp;
                                    <Icon>edit</Icon>
                                </MDTypography>
                                </MDBox>
                                <MDTypography component="div" variant="button" color="success" fontWeight="bold">
                                        <MDTypography variant="button" color="dark" fontWeight="medium">
                                            {"Product price: "}
                                        </MDTypography>
                                    {(campaign['product']['product_price']/100).toFixed(2) + " $"}
                                </MDTypography>
                               {campaign['campaign']['discounts'].map((discount) => (
                                    <Card sx={{backgroundColor: '#f8f9fa', marginTop:1, marginBottom:1, padding:3}} key={discount['code']}>
                                        <MDBox >
                                            <MDBox display="flex" justifyContent="space-between">
                                                <MDTypography component="div" variant="button" color="text" fontWeight="regular">
                                                    <MDTypography variant="button" color="dark" fontWeight="medium">
                                                        {"Discount code: "}
                                                    </MDTypography>
                                                {discount['code']}
                                                </MDTypography>
                                            </MDBox>
                                            <MDTypography component="div" variant="button" color="text" fontWeight="regular">
                                                <MDTypography variant="button" color="dark" fontWeight="medium">
                                                    {"User min level: "}
                                                </MDTypography>
                                            {discount['avatar_level']}
                                            </MDTypography>
                                            <MDTypography component="div" variant="button" color="error" fontWeight="bold">
                                                <MDTypography variant="button" color="dark" fontWeight="medium">
                                                    {"Min discounted price: "}
                                                </MDTypography>
                                            {(discount['min_discounted_price']/100).toFixed(2) + " $"}
                                            </MDTypography>
                                        </MDBox>
                                    </Card>

                               ))}
                            </MDBox>
                        }
                        {surveyType && 
                            <MDBox pt={4} pb={1}>
                                <MDTypography variant="text" color="text" fontWeight="bold">
                                    Survey target avatar&nbsp;&nbsp;&nbsp;
                                    <Icon>edit</Icon>
                                </MDTypography>
                                <Card sx={{backgroundColor: '#f8f9fa', marginTop:1, marginBottom:1, padding:3}}>
                                <Card sx={{marginTop:1, marginBottom:1, padding:3}}>
                                    {campaign['campaign']['target_avatar'].map((target) => (
                                        <MDBox key={target['target_question']} display="flex" justifyContent="space-between">
                                            <MDTypography variant="overline" color="dark" fontWeight="medium">
                                                {target['target_question']}
                                            </MDTypography>
                                            <MDTypography variant="overline" color="dark" fontWeight="regular">
                                                {target['target_answer']}  
                                            </MDTypography>
                                        </MDBox>
                                    ))}
                                </Card>
                                </Card> 
                            </MDBox>
                        }
                    </MDBox>
                </Grid>
            </Grid>
            }
        </>


    );
}